<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>运输违章罚款使用说明:
          <span>1、单号构成规则:201201+WF+4位顺序号。系统生成,添加无效</span><br>
          <span>3、查询关键字:单号、车牌。</span><br>
        </h5>
      </div>
    </div>

    <pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
      <template slot="pre_base_button">
        <button class="pre_btn_ok" @click="fun_show_step">审核流程</button>
      </template>
      <!-- <template slot="slot_c_department">
        <pre-select class="short0" ref="department" @selectFunc="selectFunc1" v-bind:searchList="list_depart"
          :selectValue="sel_depart" />
      </template> -->
    </pre-base>

    <pre-step :pre_show_tan="show_step" :pre_data="show_stepdata" />

  </div>
</template>

<script>
  import api from '@/utils/type.js';
  import {
    Method_EasySelect
  } from '@/utils/loadhttpdata.js';
  export default {
    components: {
      "pre-base": () => import("../per_old/pre_base_table_20210522.vue"),
      "pre-step": () => import("../per_old/pre_base_tan_step.vue")
    },
    data() {
      return {
        element_loading: false,
        init_data: '',
        row_id: '',
        item: '',

        // 组件
        show_tan: '0',
        show_item: '',
        // 审核流程
        show_step: '0',
        show_stepdata: '',
      };
    },
    mounted: function() {
      var that = this;
      this.$nextTick(function() {
        that.fun_init();
      });
    },
    methods: {
      fun_init: async function() {
        let t_list_department = [],
          t_list_user = [],
          t_list_car = [],
          t_list_in = [],
          t_list_out = [];

        this.element_loading = true;

        t_list_department = await this.fun_load_class('data_dep');
        // console.log(t_list_department.data);

        t_list_user = await this.fun_load_class('data_alluser');
        // console.log(t_list_user.data);

        t_list_car = await this.fun_load_class('data_exp_car', '1');
        // console.log(t_list_car.data);

        t_list_out = await this.fun_load_class('data_out_classok', 'wzfk');

        // t_list_in = await this.fun_load_class('data_in_classok', '');

        this.element_loading = false;

        this.init_data = '';
        this.init_data = JSON.stringify({
          "title": '违章罚款',
          "control": "transbad",
          "sel_action": 'exp_tr_bad',
          "upd_action": 'tr_bad',
          "d_sel_action": 'exp_tr_fee',
          "d_upd_action": 'tr2_bad_d',
          "file_action": 'tr_bad',
          "p1": 'bdwl',
          "p2": 'yunshu_bad',
          "p3": '',
          "parm_sel": [{
              "name": "单号",
              "val": "",
              "key": "sheet_no",
              "type": "text",
              "class": "long2",
              "sel": "1"
            },
            {
              "name": "车牌",
              "val": "",
              "key": "car_no",
              "type": "select",
              "class": "long1",
              "list": t_list_car.data,
              "sel_val": {},
              "sel_name": "",
              "sel": "2"
            },
            {
              "name": "部门",
              "val": "",
              "key": "d_name",
              "type": "select",
              "class": "long1",
              "list": t_list_department.data,
              "sel_val": {},
              "sel_name": "",
              "sel": "3"
            },
            {
              "name": "经办人",
              "val": "",
              "key": "u2_name",
              "type": "select",
              "class": "long1",
              "list": t_list_user.data,
              "sel_val": {},
              "sel_name": "",
              "sel": "4"
            }
          ],
          "parm": [{
              "name": "单号",
              "val": "",
              "key": "sheet_no",
              "type": "readonly",
              "class": "long2",
              "p": "1"
            },
            {
              "name": "车牌",
              "val": "",
              "key": "car_no",
              "type": "select",
              "class": "long1",
              "list": t_list_car.data,
              "sel_val": {},
              "sel_name": "",
              "weight": "1",
              "p": "1"
            },
            {
              "name": "部门",
              "val": "",
              "key": "d_name",
              "type": "readonly",
              "class": "long1"
            },
            {
              "name": "经办人",
              "val": "",
              "key": "u2_name",
              "type": "select",
              "class": "long1",
              "list": t_list_user.data,
              "sel_val": {},
              "sel_name": "",
              "weight": "1",
              "p": "1"
            },
            {
              "name": "扣分",
              "val": "",
              "key": "bad_num",
              "type": "number",
              "class": "long1",
              "weight": "1",
              "p": "1"
            },
            {
              "name": "罚款",
              "val": "",
              "key": "amount_bad",
              "type": "number",
              "class": "long1",
              "weight": "1",
              "p": "1"
            },
            {
              "name": "总金额",
              "val": "",
              "key": "amount_all",
              "type": "number",
              "class": "long1",
              "weight": "1",
              "p": "1"
            },
            {
              "name": "备注",
              "val": "",
              "key": "note",
              "type": "text",
              "class": "long3",
              "p": "1",
            }
          ],
          "parm_th": [{
              "name": "序号"
            },
            {
              "name": "单号"
            },
            {
              "name": "状态"
            },
            {
              "name": "部门"
            },
            {
              "name": "经办人"
            },
            {
              "name": "车牌号码"
            },
            {
              "name": "扣分"
            }, {
              "name": "罚款"
            },
            {
              "name": "总金额"
            },

            {
              "name": "备注"
            },
            // {
            //   "name": "经办人"
            // },
            {
              "name": "明细"
            },
            // {
            //   "name": "状态"
            // },
            {
              "name": "修改人"
            }, {
              "name": "修改时间"
            }
          ],
          "d_parm": [
            {
              "name": "单号",
              "val": '',
              "key": "sheet_no",
              "type": "none",
              "p": "1"
            },
            {
              "name": "费用名称",
              "val": "",
              "key": "p_name",
              "type": "select",
              "class": "long1",
              "list": t_list_out.data,
              "sel_val": {},
              "sel_name": "",
              "weight": "1",
              "p": "1"
            },
            {
              "name": "支出|收入",
              "val": "o",
              "key": "p_flag",
              "type": "none",
              "class": "long1",
              "p": "1"
            },
            {
              "name": "申请金额",
              "val": "",
              "key": "p_amount",
              "type": "number",
              "class": "long1",
              "p": "1"
            },
            {
              "name": "备注",
              "val": "",
              "key": "p_note",
              "type": "text",
              "class": "long3",
              "p": "1"
            }
          ],
          "d_name": [{
              "name": "ID"
            },
            {
              "name": "序号"
            },
            {
              "name": "单号"
            },
            {
              "name": "费用名称"
            },
            {
              "name": "费用金额"
            },
            {
              "name": "收入|支出"
            },
            {
              "name": "备注"
            },
            {
              "name": "有无附件"
            },
            {
              "name": "修改人"
            },
            {
              "name": "修改时间"
            },
            {
              "name": "存储地址"
            },
            {
              "name": "访问地址"
            }
          ]

        });

      },
      refresh_data: function(type) {
        var that = this;
        this.$nextTick(function() {
          that.$refs['mybase'].refresh_data(type);
        });
      },
      refresh_father: function(type, val, parm) {
        // console.log('type=' + type + ' val=' + val);
        switch (type) {
          case 'father':
            // 弹出修改明细，修改主窗口信息
            this.refresh_data();
            break;
          default:
            // console.log('子组件刷新父组件传值=' + val);
            this.row_id = val;
            this.item = parm;
            break;
        }
      },
      fun_load_class: function(action, p1, p2, p3) {

        let that = this;
        return new Promise((resolve, reject) => {
          // console.log(menuvalue);
          that.$post(
            api.http_method, Method_EasySelect(action, p1, p2, p3)
          ).then(res => {
            res = JSON.parse(res);
            resolve(res.data)
          });

        });

      },
      fun_show_step: function() {

        let sheet_no = '';
        for (let i = 0; i < this.item.length; i++) {
          if (this.item[i].key == 'sheet_no') {
            sheet_no = this.item[i].val;
            break;
          }
        }
        if (typeof(sheet_no) == "undefined" && sheet_no == '') {
          this.$message({
            message: '请选择要操作的单据信息!',
            type: 'warning'
          });
          return
        }

        console.log('sheet_no' + sheet_no);
        this.show_stepdata = '';
        this.show_stepdata = JSON.stringify({
          "title": '运输护送情景审核流程',
          "sheet_no": sheet_no,
          "sel_action": 'exp_step'
        });
        this.show_step = (Math.random() + '').substring(0, 8);

      }



    }
  };
</script>
<style scoped>
  .tab_body>td:nth-child(9) {
    display: none;
  }

  .tab_body>td:last-child {
    display: none;
  }
</style>
